import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=41f7ecbb&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&id=41f7ecbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f7ecbb",
  null
  
)

export default component.exports